import React, { FC, useRef } from 'react';
import { PageSection } from 'components';
import { useTranslation } from 'react-i18next';
import { Container, Hexa, SpeakersButton } from '../speakers/styled';
import {
    ButtonBlock,
    ButtonLinkInner,
    ButtonLinkWhiteInner,
    Description,
    DescriptionWrapper,
    Title,
    Wrapper,
} from './styled';
import { Modal, ModalBody, ModalElement } from 'kl-b2c-ui-kit';
import { QuizModal } from 'containers/pages/courses-list/components';
import { CSSObject } from 'styled-components';

const sectionConfig = {
    CWrap: {
        css: {
            paddingTop: 200,
            background: '#3DE8CA',
            backgroundImage:
                'radial-gradient(ellipse farthest-corner at 92% 95%, #4DFF88, transparent 40%), radial-gradient(ellipse farthest-side at 10% 90%, #4DFF88, transparent 40%)',

            '@media(max-width: 1279px)': {
                backgroundImage: 'none',
            },

            '@media(max-width: 1023px)': {
                paddingTop: 100,
            },
        },
    },
    ContentArea: {
        css: {
            display: 'block',
            position: 'relative',
            zIndex: 2,
        },
    },
};

interface TestProps {
    commonForm?: {
        title: string;
        description: string;
        btnLabel: string;
        action?: () => void;
    };
    styles?: CSSObject;
    isXtraining?: boolean;
    xTraining?: {
        orderTitle: string;
        buyTitle: string;
        demoTitle: string;
        buyLink?: string;
        demoLink?: string;
        action?: () => void;
    };
}

export const Test: FC<TestProps> = ({
    commonForm,
    styles,
    isXtraining,
    xTraining,
}) => {
    const { t } = useTranslation(['pages/for-businesses', 'common/errors']);
    const modalRef = useRef<ModalElement>(null);

    return (
        <>
            <Wrapper styles={styles}>
                <Hexa
                    secondary
                    image={
                        process.env.PUBLIC_URL +
                        '/assets/images/bussiness/hexa2.png'
                    }
                />
                <PageSection config={sectionConfig}>
                    <Container secondary>
                        <DescriptionWrapper>
                            <Title>
                                {commonForm?.title
                                    ? commonForm?.title
                                    : t('pages/for-businesses:test-title')}
                            </Title>
                            <Description>
                                {commonForm?.description
                                    ? commonForm.description
                                    : t(
                                          'pages/for-businesses:test-description'
                                      )}
                            </Description>
                            {!isXtraining && (
                                <SpeakersButton
                                    onClick={() =>
                                        commonForm?.action
                                            ? commonForm?.action()
                                            : modalRef?.current?.open()
                                    }
                                    variant={'contained'}
                                    color={'primary-contrast'}
                                    size={'large'}>
                                    {commonForm?.btnLabel
                                        ? commonForm?.btnLabel
                                        : t('pages/for-businesses:test-btn')}
                                </SpeakersButton>
                            )}
                            {isXtraining && (
                                <ButtonBlock>
                                    <ButtonLinkInner
                                        as={'a'}
                                        href={xTraining?.buyLink}
                                        target={'_blank'}>
                                        {xTraining?.buyTitle}
                                    </ButtonLinkInner>
                                    <SpeakersButton
                                        onClick={() =>
                                            commonForm?.action
                                                ? commonForm?.action()
                                                : modalRef?.current?.open()
                                        }
                                        variant={'contained'}
                                        color={'primary-contrast'}
                                        size={'large'}>
                                        {xTraining?.orderTitle}
                                    </SpeakersButton>
                                    <ButtonLinkWhiteInner
                                        as={'a'}
                                        href={xTraining?.demoLink}
                                        target={'_blank'}>
                                        {xTraining?.demoTitle}
                                    </ButtonLinkWhiteInner>
                                </ButtonBlock>
                            )}
                        </DescriptionWrapper>
                    </Container>
                </PageSection>
            </Wrapper>
            <Modal
                ref={modalRef}
                size={'md'}
                showClose
                styles={{
                    borderRadius: '24px',
                    overflow: 'auto',
                }}>
                <ModalBody
                    styles={{
                        minHeight: 858,
                        '@media (max-width: 639px)': {
                            padding: '40px 16px 16px',
                        },
                    }}>
                    <QuizModal />
                </ModalBody>
            </Modal>
        </>
    );
};
